export function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
/**
 * Masks an email address for display: keeps the first two characters of the
 * local part, hides the rest with asterisks, and preserves the domain — e.g.
 * `maya.lekkas@thalamos.co.uk` becomes `ma***@thalamos.co.uk`. Falls back to
 * `***` for a malformed address with no local part.
 */
export function maskEmail(email) {
    const atIndex = email.indexOf("@");
    if (atIndex <= 0) {
        return "***";
    }
    const localPart = email.slice(0, atIndex);
    return `${localPart.slice(0, 2)}***${email.slice(atIndex)}`;
}
//# sourceMappingURL=string.js.map